module.exports = __webpack_public_path__ + "front/img/text.03b99db1.png";